Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.SocialContentMediaView extends Backbone.View

  initialize: (options = {}) ->
    @socialContent = options.socialContent

  render: ->
    @$el.html @_mediaElement()
    @_renderFullSizePopups()
    this

  _mediaElement: ->
    return @_renderInstagramMedia() if @_isInstagramMedia()
    return @_renderYoutubeMedia() if @_isYoutubeMedia()
    return @_renderInstagramListeningMedia() if @_isInstagramListeningMedia()
    return @_renderTwitterMedia() if @_hasTwitterMediaFiles()
    return @_renderFacebookMedia() if @_hasFacebookMediaFiles()
    return @_renderTikTokMedia() if @_isTikTokMedia()
    return @_renderLinkedInMedia() if @_isLinkedInMedia()
    @remove()

  _renderInstagramMedia: ->
    new Monitoring.Views.SocialContents.SocialContentInstagramMediaView(
      image: (@socialContent.image() if @_isInstagramImage())
      fullImage: (@socialContent.fullImage() if @_isInstagramImage())
      video: (@socialContent.video() if @_isInstagramVideo())
    ).render().el

  _renderYoutubeMedia: ->
    new Monitoring.Views.SocialContents.SocialContentYoutubeMediaView(
      video: @socialContent._getContent().getLink()
      thumbnail: @socialContent._getContent().getVideoThumbnail()
    ).render().el

  _renderInstagramListeningMedia: ->
    new Monitoring.Views.SocialContents.SocialContentInstagramMediaView(
      image: @socialContent._getContent().imageUrl()
      fullImage: @socialContent._getContent().imageUrl()
      video: @socialContent._getContent().videoUrl()
    ).render().el

  _renderTwitterMedia: ->
    new Monitoring.Views.SocialContents.SocialContentTwitterMediaView(
      mediaFiles: @socialContent.getMedias()
      canPlayMP4: @socialContent.canPlayVideoType('video/mp4')
      socialContent: @socialContent
    ).render().el

  _renderFacebookMedia: ->
    new Monitoring.Views.SocialContents.SocialContentFacebookMediaView(
      picture: @socialContent.picture()
      video: (@socialContent.video?())
    ).render().el

  _renderTikTokMedia: ->
    new Monitoring.Views.SocialContents.SocialContentTikTokMediaView(
      video: @socialContent.videoUrl()
      thumbnail: @socialContent.videoThumbnailUrl()
      showVideoAsLink: @socialContent.showVideoAsLink()
    ).render().el

  _renderLinkedInMedia: ->
    new Monitoring.Views.SocialContents.SocialContentLinkedInMediaView(
      link: @socialContent._getContent().postURL()
    ).render().el

  _isInstagramListeningMedia:->
    @socialContent.type() == 'instagram' &&
      (@socialContent.subType() == 'instagram_listening_media' || @socialContent.subType() == 'instagram_business_discovery_listening_media' || @socialContent.origin() == 'instagram_listening_media' || @socialContent.origin() == 'instagram_business_discovery_api') &&
      (@socialContent._getContent().imageUrl() || @socialContent._getContent().videoUrl())

  _isInstagramMedia: ->
    @socialContent.type() == 'instagramMedia'

  _isYoutubeMedia: ->
    @socialContent.subType() == 'yt-video'

  _isInstagramImage: ->
    @socialContent.isImage()

  _isInstagramVideo: ->
    @socialContent.isVideo()

  _hasTwitterMediaFiles: ->
    @socialContent.getMedias?().length

  _hasFacebookMediaFiles: ->
    @socialContent.subType() == 'fb-post' and @socialContent.picture?()

  _isTikTokMedia: ->
    @socialContent.type() == 'tiktok' and @socialContent.isVideo()

  _isLinkedInMedia: ->
    @socialContent.type() == 'linkedin' and @socialContent.subType() == 'li-post' and @socialContent._getContent().hasMedia()

  _renderFullSizePopups: ->
    @$el.find('.sc-picture-preview').magnificPopup(type: 'image', closeOnContentClick: true)
    @$el.find('.sc-video-preview').magnificPopup(type: 'iframe', closeOnContentClick: true)
